/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IconYoutube1 = ({ className }) => {
    return (
        <svg
            className={`icon-youtube-1 ${className}`}
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="path"
                d="M21.593 7.203C21.4791 6.7804 21.2565 6.395 20.9474 6.08517C20.6382 5.77533 20.2533 5.55186 19.831 5.437C18.265 5.007 12 5 12 5C12 5 5.73599 4.993 4.16899 5.404C3.74692 5.52415 3.36282 5.75078 3.05356 6.06213C2.7443 6.37349 2.52028 6.75912 2.40299 7.182C1.98999 8.748 1.98599 11.996 1.98599 11.996C1.98599 11.996 1.98199 15.26 2.39199 16.81C2.62199 17.667 3.29699 18.344 4.15499 18.575C5.73699 19.005 11.985 19.012 11.985 19.012C11.985 19.012 18.25 19.019 19.816 18.609C20.2385 18.4943 20.6237 18.2714 20.9336 17.9622C21.2436 17.653 21.4674 17.2682 21.583 16.846C21.997 15.281 22 12.034 22 12.034C22 12.034 22.02 8.769 21.593 7.203ZM9.99599 15.005L10.001 9.005L15.208 12.01L9.99599 15.005Z"
                fill="black"
            />
        </svg>
    );
};
